import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { EstadosService } from 'src/app/services/estados.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPaginator } from '@angular/material/paginator';
import { ComproCabeProveService } from 'src/app/services/compro-cabe-prove.service';
import { MatTableDataSource } from '@angular/material/table';
import { formatDate } from '@angular/common';
import { AlertModalComponent } from 'src/app/shared/alert-modal/alert-modal.component';
import Swal from 'sweetalert2';
import * as moment from 'moment';

export const DATE_FORMATS = {
  parse: {
      dateInput: 'DD/MM/YYYY',
  },
  display: {
      dateInput: 'DD/MM/YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-facturas-proveedores',
  templateUrl: './facturas-proveedores.component.html',
  styleUrl: './facturas-proveedores.component.scss',
  providers: [{ provide: DateAdapter, useClass:MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    {provide: MAT_DATE_LOCALE, useValue: 'es-ES'},
    {provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS}]  
})
export class FacturasProveedoresComponent implements AfterViewInit {
  displayedColumns: string[] = ['estado', 'descrip','sucur','num', 'fecha','total','saldo','fecha_vencimiento'];
  dataSource: any;
  fecha_desde_moment: moment.Moment = moment().subtract(3, 'months');
  fecha_hasta_moment: moment.Moment = moment();
  fecha_desde: any = moment().subtract(3, 'months').format('YYYYMMDD');
  fecha_hasta: any = moment().format('YYYYMMDD');
  estado:any ='PEN';
  value: any ='';
  estados: any='';
  data:any;
  estaVacio:boolean=true;
  contador: number = 0;
  total_pendiente:number = 0;
  total:number = 0;
  mult: any;

  constructor(public compService:ComproCabeProveService, public estadoService:EstadosService, private paginator2: MatPaginatorIntl) {
    this.paginator2.itemsPerPageLabel = "Registros por página"}
    nro_cuenta: any = localStorage.getItem('cuenta');
    nro_cli: any = localStorage.getItem('nro_cliente');
    nro_prov: any = '';
    isLoadingResults: Boolean = true;

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    ngAfterViewInit() {
    this.estadoService.consulEst()
    .then((data:any)=>{
      this.estados=data;
    })
    this.consultar();
  }

  dateChanged($event:any){
    // fecha= new Date($event.target.value);
    console.log(this.fecha_desde);
    this.isLoadingResults = true;
    if($event.value){
      this.fecha_desde_moment = $event.value;
      this.fecha_desde = this.fecha_desde_moment.format('YYYYMMDD');
      } else {
        this.fecha_desde = '';
        this.fecha_desde_moment = null as any;
      }
    this.consultar();
  }

  dateChanged2($event:any){
    this.isLoadingResults = true;
    if($event.value){
      this.fecha_hasta_moment = $event.value;
      this.fecha_hasta = this.fecha_hasta_moment.format('YYYYMMDD');
    } else {
      this.fecha_hasta = '';
      this.fecha_hasta_moment = null as any;
    }
    this.consultar();

  }

  setEstado(){
    this.consultar();
  }

  formatearNumero(numero: any,cantidad: number): string {
    if (!numero && numero !== 0) return '';
    return String(numero).padStart(cantidad, '0');
  }

  consultar(){
    this.isLoadingResults = true;
    this.compService.obtenerComprobantes(
      { fecha_desde: this.fecha_desde, fecha_hasta: this.fecha_hasta, estado: this.estado }
    ).subscribe({
      next: (data:any)=>{
        try {

          if(data){
            this.total_pendiente = 0;
            this.total = 0;
            for (let i = 0; i < data.length; i++) {
              // Convertir vencimiento a Date si existe y es string
              this.total = this.total + Number(data[i].total);
              this.total_pendiente = this.total_pendiente + Number(data[i].saldo * data[i].mone_coti);
              const fechaVencimiento = data[i].vencimiento ? new Date(data[i].vencimiento) : null;
              const hoy = new Date();
              hoy.setHours(0, 0, 0, 0); // Resetear horas para comparar solo fechas
              
              if (fechaVencimiento) {
                fechaVencimiento.setHours(0, 0, 0, 0);
              }
              
              data[i].comp_vencido = fechaVencimiento && 
                                     fechaVencimiento < hoy && 
                                     data[i].estado == 'PEN' && 
                                     data[i].saldo > 0 ? 'S' : 'N';
            }
            console.log(data);
            this.dataSource = new MatTableDataSource(data);
            this.dataSource.paginator = this.paginator;
            this.data = data;
            this.data.length==0?this.estaVacio=false:this.estaVacio=true;
            this.contador=0;
          }
          this.isLoadingResults = false;
        } catch (error) {
          this.isLoadingResults = false;
          this.dataSource = new MatTableDataSource([]);
          this.dataSource.paginator = this.paginator;
          this.data = [];
          this.estaVacio=true;
        }
      },
      error: (error:any)=>{
        this.isLoadingResults = false;
        this.dataSource = new MatTableDataSource([]);
        this.dataSource.paginator = this.paginator;
        this.data = [];
        this.estaVacio=true;
        
        // Extraer el mensaje de error correctamente
        let mensajeError = 'Error desconocido';
        if (error?.originalError?.error?.message) {
          mensajeError = error.originalError.error.message;
        } else if (error?.error?.message) {
          mensajeError = error.error.message;
        } else if (error?.message) {
          mensajeError = error.message;
        }
        
        Swal.fire({
          title: 'Error',
          text: mensajeError,
          icon: 'error'
        });
      }
    });
  }
}
